import React, { useContext } from 'react';
import { ICardBoxProviderState } from './card-box.types';

export const CardBoxProvider = React.createContext<ICardBoxProviderState>({
    opened: false,
    setOpened: () => {},
    allowCollapse: false
});

export const useCardBoxContext = () => useContext(CardBoxProvider);
